<!-- 库存审批 -->
<template>
  <div class="app-container" v-loading="fullscreenLoading">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :showText="true"
      :isCreateSearch="false"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :disabledBtn="disabledBtn == '1'"
      rowKey="checkInventoryProductRecordId"
      exportDataUrl="/checkInventory/selectCheckInventoryProductRecordAndRealInventoryTotal"
      tableName="approvalInventory"
      :customParamsFun="getCustomParamsFun"
      @onSearch="handleSearch"
    >
      <template #funBtn>
        <el-row :gutter="8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              v-hasPermi="['checkInventory::approvalCheckInventory::submit']"
              :disabled="disabledBtn == '1'"
              @click="handleCheckEnd"
              >提交审批结果</el-button
            >
          </el-col>
        </el-row>
      </template>
      <template #textInfo>
        <el-row class="textInfo" :gutter="8">
          <el-col :span="5">
            <div>
              <span class="textName">{{
                checkInventoryRecord.warehouseName
              }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="textName">主材：</span
              >{{ checkInventoryRecord.mainMaterialTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="textName">辅材：</span
              >{{ checkInventoryRecord.auxiliaryMaterialTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              <span class="textName">耗材：</span
              >{{ checkInventoryRecord.consumptionMaterialTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="textName">总数：</span
              >{{ checkInventoryRecord.inventoryTotal || 0 }}
            </div>
          </el-col>
        </el-row>
      </template>
    </Table>
    <!-- 详情 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogOpen"
      width="1200px"
      append-to-body
      @close="closed"
    >
      <Table
        ref="tableRefDialog"
        :showSearchIcon="true"
        :isCreateSearch="false"
        :isSelect="true"
        :data="tableDataDialog"
        :columns="columnsDialog"
        :total="totalDialog"
        :loading="loadingDialog"
        :disabledBtn="disabledBtn == '1'"
        rowKey="productInventoryId"
        tableName="approvalInventoryProDetail"
        exportDataUrl="/checkInventory/selectCheckInventoryCheckRecord"
        :customParamsFun="getCustomParamsFunPro"
        @onSearch="handleSearchDialog"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">关闭</el-button>
          <!-- <el-button type="primary" @click="onConfirm">{{ $t('msg.universal.confirm') }}</el-button> -->
        </span>
      </template>
    </el-dialog>
    <!-- 查缺详情主材 -->
    <el-dialog
      title="查缺结果"
      v-model="dialogCheckedEqpt"
      width="1300px"
      append-to-body
    >
      <span class="mb10" style="font-size: 25px; color: red"
        >以下设备存在异常情况，请处理！</span
      >
      <Table
        ref="tableRefDialogChecked"
        :showSearchIcon="true"
        :isSelect="true"
        :isCreateSearch="false"
        :data="tableDataDialogChecked"
        :columns="columnsDialogCheck"
        :total="totalDialogCheck"
        :loading="loadingCheck"
        @onSearch="handleSearchDialogChecked"
        height="500px"
        tableName="approvalInventoryProChecked"
        :customParamsFun="getCustomParamsFunPro"
        rowKey="productInventoryId"
        @changeInput="changeInput"
        @changeSelect="changeSelect"
        @onSelectChange="onSelectChange"
      >
        <template #funBtn>
          <el-form
            ref="formSelectRef"
            :inline="true"
            :model="formSelectDate"
            :rules="formSelectRules"
          >
            <el-form-item label="处理方式" prop="disposalMode">
              <el-select
                v-model="formSelectDate.disposalMode"
                style="width: 200px"
                filterable
                placeholder="请选择处理方式"
              >
                <el-option
                  v-for="(item, index) in disposalModeList"
                  :key="item.libraryId + index"
                  :label="item.libraryName"
                  :value="item.libraryCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="处理意见">
              <el-input
                v-model="formSelectDate.remarks"
                placeholder="请填写处理意见"
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeCheckedEqpt">关闭</el-button>
          <el-button type="primary" @click="onConfirmCheckedEqpt">{{
            $t("msg.universal.confirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 查缺结果辅材/耗材 -->
    <el-dialog
      title="查缺结果"
      v-model="dialogChecked"
      width="600px"
      append-to-body
    >
      <div class="mb10" style="font-size: 25px; color: red">
        盘点库存与实时库存数量不一致，请处理！
      </div>
      <div class="checkContain mb10">
        <div><span>应在库：</span>{{ checkForm.inventoryTotal || 0 }}</div>
        <div><span>盘点库存：</span>{{ checkForm.actualTotal || 0 }}</div>
        <div>
          <span>实时库存：</span>{{ checkForm.realInventoryTotal || 0 }}
        </div>
      </div>
      <el-tabs v-model="activeName" stretch tab-position="left">
        <el-tab-pane label="处理方式" name="approvalType">
          <div>
            <el-select
              style="width: 300px"
              v-model="checkForm.disposalMode"
              filterable
              clearable
              placeholder="请选择处理方式"
            >
              <el-option
                v-for="subItem in processingList"
                :key="subItem.processingId"
                :label="subItem.processingName"
                :value="subItem.processingId"
              />
            </el-select>
            <div v-show="checkForm.disposalMode == '2'" class="mt10 inputClass">
              <span>实际库存：</span>
              <el-input
                style="width: 230px"
                v-model="checkForm.num"
                clearable
                @input="
                  checkForm.num = checkForm.num.replace(/^0+(\d)|[^\d]+/g, '')
                "
              />
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="处理意见" name="approvalInput">
                    <el-input style="width:300px" placeholder="请输入处理意见" v-model="checkForm.remark"></el-input>
                </el-tab-pane> -->
      </el-tabs>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeChecked">关闭</el-button>
          <el-button type="primary" @click="onConfirmChecked">{{
            $t("msg.universal.confirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 审批结果存在未审批数据（辅材耗材） -->
    <el-dialog
      title="审批异常"
      v-model="dialogApprovalErr"
      width="1300px"
      append-to-body
    >
      <span class="mb10" style="font-size: 25px; color: red"
        >以下设备未审批请仔细核对！</span
      >
      <Table
        :showSearchIcon="false"
        :data="tableDataDialogErr"
        :columns="columnsDialogErr"
        height="500px"
        tableName="approvalInventoryProErr"
        rowKey="productInventoryId"
        @changeInput="changeInput"
        @changeSelect="changeSelect"
        @onSelectChange="onSelectChange"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeApprovalErr">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 审批结果存在未审批数据（主材） -->
    <el-dialog
      title="审批异常"
      v-model="dialogApprovalErrMain"
      width="1300px"
      append-to-body
    >
      <span class="mb10" style="font-size: 25px; color: red"
        >以下设备未审批请仔细核对！</span
      >
      <Table
        :showSearchIcon="true"
        :isSelect="true"
        :data="tableDataDialogErrMain"
        :columns="columnsDialogCheck"
        height="500px"
        tableName="approvalInventoryProErrMain"
        rowKey="productInventoryId"
        @changeInput="changeInput"
        @changeSelect="changeSelect"
        @onSelectChange="onSelectChange"
      >
        <template #funBtn>
          <el-form
            ref="formSelectRef"
            :inline="true"
            :model="formSelectDate"
            :rules="formSelectRules"
          >
            <el-form-item label="处理方式" prop="disposalMode">
              <el-select
                v-model="formSelectDate.disposalMode"
                style="width: 200px"
                filterable
                placeholder="请选择处理方式"
              >
                <el-option
                  v-for="(item, index) in disposalModeList"
                  :key="item.libraryId + index"
                  :label="item.libraryName"
                  :value="item.libraryCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="处理意见">
              <el-input
                v-model="formSelectDate.remarks"
                placeholder="请填写处理意见"
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeApprovalErrMain">关闭</el-button>
          <el-button type="primary" @click="onConfirmCheckedEqpt">{{
            $t("msg.universal.confirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { ref, watch, onMounted, getCurrentInstance } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  selectCheckInventoryProductRecordAndRealInventoryTotal,
  selectCheckInventoryCheckRecord,
  checkInventoryApprovalEnd,
  checkInventoryApprovalMainDisposalMode,
  checkInventoryApprovalOtherDisposalMode,
  selectMainApprovalError,
  selectOtherApprovalError,
  updateCheckRecord,
} from "@/api/checkInventory";
import useCacheStore from "@/store/modules/cache";
import { isNull, feArrayObjectJoin } from "@/utils/fangerUtils";
import { succesMsg, infoMsg, errorMsg, confirmBox } from "@/utils/msgBox";
import useInventoryStore from "@/store/modules/inventory";
const inventoryStore = useInventoryStore();
const cacheStore = useCacheStore();
const { proxy } = getCurrentInstance();
const { getDictNameByPCodeSCode, getDictListByParentCode } = cacheStore;
const props = defineProps({
  checkInventoryRecord: {
    // 盘库id
    required: false,
    type: Object,
  },
});
onMounted(() => {
  watch(
    () => props.checkInventoryRecord,
    (newVal, oldVal) => {
      disabledBtn.value = newVal.approvalStatus;
      tableRef.value.onSearch();
      // proSearch()
    },
    {
      immediate: true,
      deep: true,
    }
  );
  if (sessionStorage.getItem("approvalStatus") === "1") {
    disabledBtn.value = "1";
  }
});
const tableRef = ref(null);
const tableData = ref([]);
const total = ref(0);
const loading = ref(false);
const tableDataDialog = ref([]);
const totalDialog = ref(0);
const loadingDialog = ref(false);
const dialogOpen = ref(false);
const dialogTitle = ref("详情");
const tableDataDialogChecked = ref([]);
const tableDataDialogErrMain = ref([]);
const dialogCheckedEqpt = ref(false);
const fullscreenLoading = ref(false);
const dialogApprovalErrMain = ref(false);
const disabledBtn = ref("0");
const activeName = ref("approvalType");
const processingList = ref([
  { processingId: "1", processingName: "按照当前盘点库存数" },
  { processingId: "2", processingName: "输入实际库存数" },
  { processingId: "3", processingName: "不做处理" },
]);
const disposalModeList = ref();
const closeChecked = () => {
  checkForm.value = {};
  dialogChecked.value = false;
};
const closeCheckedEqpt = () => {
  tableDataDialogChecked.value = [];
  disposalModeList.value = [];
  dialogCheckedEqpt.value = false;
};
const dialogApprovalErr = ref(false);
const mainErr = ref(false);
const tableDataDialogErr = ref([]);
//  提交审批结果
const handleCheckEnd = async () => {
  fullscreenLoading.value = true;
  mainErr.value = false;
  const otherRes = await selectOtherApprovalError({
    checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
  });
  if (otherRes.data.length > 0) {
    columnsErr.value = columnsDialogErr;
    dialogApprovalErr.value = true;
    tableDataDialogErr.value = otherRes.data;
    fullscreenLoading.value = false;
  } else {
    const mainRes = await selectMainApprovalError({
      checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
    });
    if (mainRes.data.length > 0) {
      disposalModeList.value = getDictListByParentCode("disposalMode");
      dialogApprovalErrMain.value = true;
      mainErr.value = true;
      tableDataDialogErrMain.value = mainRes.data;
      fullscreenLoading.value = false;
    } else {
      const approvalRes = await checkInventoryApprovalEnd({
        checkInventoryRecordId:
          props.checkInventoryRecord.checkInventoryRecordId,
      });
      if (approvalRes.status == 1) {
        succesMsg("审批完成");
        sessionStorage.setItem("approvalStatus", "1");
        disabledBtn.value = "1";
        inventoryStore.approvalInventoryStatus = "1";
      } else {
        errorMsg("审批失败");
      }
      fullscreenLoading.value = false;
    }
  }
};

const closeApprovalErr = () => {
  dialogApprovalErr.value = false;
  tableDataDialogErr.value = [];
};
const closeApprovalErrMain = () => {
  dialogApprovalErrMain.value = false;
  tableDataDialogErrMain.value = [];
  disposalModeList.value = [];
};

//   辅材处理方式
const onConfirmChecked = () => {
  checkInventoryApprovalOtherDisposalMode({
    checkInventoryProductRecordId:
      checkForm.value.checkInventoryProductRecordId,
    disposalMode: checkForm.value.disposalMode,
    approvalInventoryTotal: checkForm.value.num,
  })
    .then((res) => {
      if (res.status == 1) {
        succesMsg("处理成功");
        checkForm.value = {};
        dialogChecked.value = false;
      }
    })
    .catch((res) => {
      errorMsg("处理失败");
    });
};
const selectVals = ref([]);
const onSelectChange = (vals) => {
  selectVals.value = [];
  selectVals.value = vals;
};
const formSelectDate = ref({});
const formSelectRef = ref(null);
const formSelectRules = ref({
  disposalMode: [
    { required: true, trigger: "blur", message: "处理方式不能为空" },
  ],
});
const onConfirmCheckedEqpt = () => {
  if (selectVals.value.length > 0) {
    formSelectRef.value.validate(async (valid) => {
      // 不合规直接返回
      if (!valid) return;
      const checkInventoryCheckRecordIds = feArrayObjectJoin(
        selectVals.value,
        "checkInventoryCheckRecordId",
        ","
      );
      checkInventoryApprovalMainDisposalMode({
        checkInventoryCheckRecordId: checkInventoryCheckRecordIds,
        ...formSelectDate.value,
        disposalMode: getDictNameByPCodeSCode(
          "disposalMode",
          formSelectDate.value.disposalMode
        ),
      }).then((res) => {
        succesMsg("处理成功");
        closeCheckedEqpt();
        closeApprovalErrMain();
      });
    });
  } else {
    closeCheckedEqpt();
    closeApprovalErrMain();
  }
};
const tableRefDialog = ref(null);
const getCustomParamsFun = () => {
  return {
    checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
  };
};
// 搜索
const handleSearch = (data) => {
  loading.value = true;
  selectCheckInventoryProductRecordAndRealInventoryTotal(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .finally(() => {
      loading.value = false;
    });
};
const checkInventoryProductRecordId = ref("");
const getCustomParamsFunPro = () => {
  return {
    checkInventoryProductRecordId: checkInventoryProductRecordId.value,
  };
};
//   详情
const handleSearchDialog = (data) => {
  loadingDialog.value = true;
  selectCheckInventoryCheckRecord(data)
    .then((res) => {
      const arr = [];
      res.data.forEach((item) => {
        item.checkStatus = getDictNameByPCodeSCode(
          "checkStatus",
          item.checkStatus
        );
      });
      tableDataDialog.value = res.data;
      totalDialog.value = res.pageParam.totleInfo;
    })
    .finally(() => {
      loadingDialog.value = false;
    });
};
const loadingCheck = ref(false);
const totalDialogCheck = ref();
//   主材查缺
const tableRefDialogChecked = ref(null);
const handleSearchDialogChecked = (data) => {
  loadingCheck.value = true;
  const whereSql = [
    { column: "checkStatus", querLogic: "ne", value: "1" },
    { column: "checkStatus", querLogic: "ne", value: "3" },
  ];
  selectCheckInventoryCheckRecord({
    ...data,
    whereSql: JSON.stringify(whereSql),
  })
    .then((res) => {
      const arr = [];
      res.data.forEach((item) => {
        item.checkStatus = getDictNameByPCodeSCode(
          "checkStatus",
          item.checkStatus
        );
      });
      tableDataDialogChecked.value = res.data;
      totalDialogCheck.value = res.pageParam.totleInfo;
    })
    .finally(() => {
      loadingCheck.value = false;
    });
};

//   修改备注信息
const changeInput = (row) => {
  updateCheckRecord({
    checkInventoryCheckRecordId: row.checkInventoryCheckRecordId,
    remarks: row.remarks,
  })
    .then((res) => {
      if (res.status == 1) {
        succesMsg("备注成功");
      }
    })
    .catch((err) => {
      errorMsg("备注失败");
    });
};

// 主材处理方式
const changeSelect = (row) => {
  updateCheckRecord({
    checkInventoryCheckRecordId: row.checkInventoryCheckRecordId,
    disposalMode: getDictNameByPCodeSCode("disposalMode", row.disposalMode),
  })
    .then((res) => {
      succesMsg("处理成功");
    })
    .catch((err) => {
      errorMsg("处理失败");
    });
};

const productId = ref(null);
const handleDetail = (event, row) => {
  dialogTitle.value = "详情";
  dialogOpen.value = true;
  checkInventoryProductRecordId.value = row.checkInventoryProductRecordId;
  productId.value = row.productId;
  proxy.$nextTick(() => {
    tableRefDialog.value.onSearch();
  });
};
const dialogChecked = ref(false);
const checkForm = ref({});
const handleCheck = (event, row) => {
  checkInventoryProductRecordId.value = row.checkInventoryProductRecordId;
  if (row.usageType !== "1") {
    dialogChecked.value = true;
    checkForm.value = row;
  } else {
    dialogCheckedEqpt.value = true;
    disposalModeList.value = getDictListByParentCode("disposalMode");
    proxy.$nextTick(() => {
      tableRefDialogChecked.value.onSearch();
    });
  }
};
const closed = () => {
  dialogOpen.value = false;
  checkInventoryProductRecordId.value = "";
  productId.value = null;
  tableDataDialog.value = [];
  tableRef.value.onSearch();
};
const handleControlDisabled = (row) => {
  return row.usageType !== "1";
};
const handleCheckDisabled = (row) => {
  return row.actualTotal == row.inventoryTotal;
};
const columns = getCustomTableCols([
  "productName",
  "productType",
  "warehouse",
  "usageType",
  "inventoryStatus",
  "inventoryTotal",
  "realInventoryTotal",
  "approvalInventoryTotal",
  {
    label: "盘点库存",
    prop: "actualTotal",
  },
  {
    label: "处理方式",
    prop: "disposalMode",
    type: "dict",
    dictKey: "otherDisposalMode",
  },
  "checkingOutInventoryTotal",
  "operateTime",
  "operatorName",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "详情",
        controlType: "success",
        controlText: true,
        controlFun: handleDetail,
        controlDisabled: handleControlDisabled,
      },
      {
        control: "button",
        controlName: "查缺",
        controlType: "success",
        controlText: true,
        controlFun: handleCheck,
        controlDisabled: handleCheckDisabled,
      },
    ],
  },
]);
const columnsDialog = getCustomTableCols([
  "eqptCode",
  "inventoryOperationType",
  "inventoryStatus",
  "inWarehouseTime",
  "outWarehouseTime",
  "checkStatus",
  "status",
  "checkTime",
  "remarks",
  "operateTime",
  "operatorName",
]);
const columnsDialogCheck = getCustomTableCols([
  "eqptCode",
  "inventoryOperationType",
  "inventoryStatus",
  "inWarehouseTime",
  "outWarehouseTime",
  "status",
  "checkStatus",
  "checkTime",
  "disposalMode",
  {
    label: "备注",
    prop: "remarks",
    type: "input",
  },
  "operateTime",
  "operatorName",
]);
const columnsDialogErr = getCustomTableCols([
  "productName",
  "productType",
  "warehouse",
  "usageType",
  "inventoryStatus",
  "inventoryTotal",
  {
    label: "盘点在库",
    prop: "actualTotal",
  },
  "checkingOutInventoryTotal",
  "operateTime",
  "operatorName",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "查缺",
        controlType: "success",
        controlText: true,
        controlFun: handleCheck,
        controlDisabled: handleCheckDisabled,
      },
    ],
  },
]);
const columnsErr = ref([]);
</script>

<style lang="scss" scoped>
.textInfo {
  font-size: 18px;
  width: 80%;
  color: #ed064b;
  font-weight: bold;
  .textName {
    font-size: 20px;
    color: #555;
  }
}
.checkContain {
  display: flex;
  // justify-content: center;
  font-size: 18px;
  color: #ed064b;
  div {
    margin-bottom: 5px;
    &:not(:first-child) {
      margin-left: 15px;
    }
    span {
      font-weight: bold;
      color: #555555;
    }
  }
}
.inputClass {
  display: flex;
  align-items: center;
}
</style>
